import { authenticatedApi } from './api';

const createOffer = async (offerData: any) => {
  return authenticatedApi.post('offer/create', offerData);
};

const getAllOffers = async () => {
  return authenticatedApi.get('offer/all');
};
const getOffer = async (offerId: string) => {
  return authenticatedApi.get(`offer/${offerId}`);
};

const getOffersPaginated = async (page: number, limit: number, filter: any) => {
  return authenticatedApi.post(`offer`, { page, limit, filter });
};

const deleteOffer = async (offerId: string) => {
  return authenticatedApi.delete(`offer/delete/${offerId}`);
};

const updateOffer = async (offerId: string, offerInput: any) => {
  return authenticatedApi.put(`offer/update/${offerId}`, offerInput);
};
const orderedOffer = async (offerId: string, offerInput: any) => {
  return authenticatedApi.put(`offer/ordered/${offerId}`, offerInput);
};
const changeStatusOffer = async (offerId: string, offerInput: any) => {
  return authenticatedApi.put(`offer/changestatus/${offerId}`, offerInput);
};
const offerApi = { createOffer, getAllOffers, getOffer, deleteOffer, updateOffer, orderedOffer, changeStatusOffer, getOffersPaginated };

export default offerApi;
